import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { MascotImage } from '@/components/mascot/MascotImage';
import { useTourStore } from '@/hooks/useTour';
import { useGuest } from '@/contexts/GuestContext';

export const TourPromptDialog = () => {
  const { showPrompt, startTour, dismissTour } = useTourStore();
  const { isGuest } = useGuest();
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleStartTour = () => {
    startTour();
  };

  const handleDismiss = () => {
    dismissTour(dontShowAgain);
  };

  return (
    <Dialog open={showPrompt} onOpenChange={(open) => {
      if (!open) handleDismiss();
    }}>
      <DialogContent className="sm:max-w-md">
        <div className="flex flex-col items-center gap-4">
          <div className="w-32 h-32">
            <MascotImage variant="welcome" className="w-full h-full" />
          </div>
          
          <DialogHeader className="text-center space-y-2">
            <DialogTitle className="text-2xl">
              {isGuest ? "Let's Show You Around!" : "Welcome to Wellness Cowgirl!"}
            </DialogTitle>
            <DialogDescription className="text-base">
              {isGuest 
                ? "Take a quick tour to see how to find events, connect with buddies, and join herds!"
                : "Want a quick tour to discover how to find events, connect with buddies, and join herds?"
              }
            </DialogDescription>
          </DialogHeader>

          <div className="flex items-center space-x-2 mt-2">
            <Checkbox
              id="dont-show"
              checked={dontShowAgain}
              onCheckedChange={(checked) => setDontShowAgain(checked as boolean)}
            />
            <label
              htmlFor="dont-show"
              className="text-sm text-muted-foreground cursor-pointer"
            >
              Don't show me this again
            </label>
          </div>

          <div className="flex gap-3 w-full mt-2">
            <Button 
              onClick={handleStartTour}
              className="flex-1"
              size="lg"
            >
              {isGuest ? "Start Tour" : "Take the Tour"}
            </Button>
            <Button 
              onClick={handleDismiss}
              variant="ghost"
              className="flex-1"
              size="lg"
            >
              Maybe Later
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
